<template>
    <div class="d-flex min-vh-100">
      <Aside />
      <main class="flex-grow-1 bg-light">
        <div class="p-4">
          <h2 class="mb-4">Ajouter un utilisateur</h2>
          <div class="card shadow-sm p-4">
            <form @submit.prevent="registerUser">
              <div class="mb-3">
                <label for="firstname" class="form-label">Prénom</label>
                <input type="text" id="firstname" class="form-control" v-model="user.firstname" required />
              </div>
              <div class="mb-3">
                <label for="lastname" class="form-label">Nom</label>
                <input type="text" id="lastname" class="form-control" v-model="user.lastname" required />
              </div>
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="email" id="email" class="form-control" v-model="user.email" required />
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">Mot de passe</label>
                <input type="password" id="password" class="form-control" v-model="user.password" required />
              </div>
              <div class="mb-3">
                <label for="password_confirmation" class="form-label">Confirmer le mot de passe</label>
                <input type="password" id="password_confirmation" class="form-control" v-model="user.password_confirmation" required />
              </div>
              <button type="submit" class="btn btn-primary">Ajouter l'utilisateur</button>
            </form>
          </div>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  import axios from "@/api/axios.js";
  import Aside from "@/components/Aside.vue";
  import Swal from "sweetalert2";
  
  export default {
    components: {
      Aside,
    },
    data() {
      return {
        user: {
          firstname: '',
          lastname: '',
          email: '',
          password: '',
          password_confirmation: '',
        }
      };
    },
    methods: {
      registerUser() {
        // Envoie des données au backend via l'API
        axios
          .post("/register", this.user)
          .then((response) => {
            // Affichage d'un message de succès
            Swal.fire({
              icon: "success",
              title: "Utilisateur ajouté",
              text: "L'utilisateur a été ajouté avec succès.",
            });
            // Réinitialisation du formulaire
            this.user = {
              firstname: '',
              lastname: '',
              email: '',
              password: '',
              password_confirmation: '',
            };
          })
          .catch((error) => {
            if (error.response && error.response.data.errors) {
              // Affichage des erreurs de validation
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: Object.values(error.response.data.errors)
                  .map((err) => err.join(" "))
                  .join(", "),
              });
            } else {
              // Erreur générique si l'API renvoie une erreur différente
              Swal.fire({
                icon: "error",
                title: "Erreur",
                text: "Une erreur est survenue lors de l'ajout de l'utilisateur.",
              });
            }
          });
      },
    },
  };
  </script>
  
  <style>
  /* Ajoutez ici des styles si nécessaire */
  </style>
  